import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';

const AuthLayout = ({ children }) => {
  const { locale, setLocale, availableLocales } = useI18n();

  return (
    <div className="min-h-screen bg-[#1A1D23] flex flex-col">
      {/* Header */}
      <header className="h-16 flex items-center justify-between px-6 border-b border-white/5">
        <Link to="/" className="flex items-center gap-2" data-testid="auth-logo">
          <div className="w-8 h-8 bg-[#EC2229] rounded-lg flex items-center justify-center">
            <span className="font-heading font-bold text-white text-sm">TX</span>
          </div>
          <span className="font-heading font-bold text-white text-lg">TrXL Performance</span>
        </Link>

        {/* Language Selector */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button 
              className="flex items-center gap-1 px-3 py-2 text-slate-400 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              data-testid="auth-language-selector"
            >
              <span className="text-lg">{availableLocales.find(l => l.code === locale)?.flag}</span>
              <span className="hidden sm:inline text-sm">{availableLocales.find(l => l.code === locale)?.name}</span>
              <ChevronDown className="w-4 h-4" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="bg-[#23272F] border-white/10">
            {availableLocales.map(l => (
              <DropdownMenuItem 
                key={l.code}
                onClick={() => setLocale(l.code)}
                className={locale === l.code ? 'bg-white/5' : ''}
              >
                <span className="mr-2">{l.flag}</span>
                <span>{l.name}</span>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 px-6 border-t border-white/5">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} TrXL Performance. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
            <Link to="/agb" className="hover:text-white transition-colors">AGB</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
